import { cloneDeep, merge } from 'lodash';
import { RECEIVE_LEAD } from '../actions/lead';
import { LOGOUT } from '../actions/login';

const initialState = { byIds: {}, allIds: [] };
export const leadReducer = (state = initialState, action) => {
  const { type } = action;
  let byIds = cloneDeep(state?.byIds || {});

  switch (type) {
    case RECEIVE_LEAD:
      let lead = action?.payload;
      byIds = merge(byIds, { [lead.seq]: lead });
      return { ...state, byIds };

    case LOGOUT:
      return { ...initialState };

    default:
      return { ...state };
  }
};
export default leadReducer;